import { render, staticRenderFns } from "./BoCustomerAutorisationsRgbd.vue?vue&type=template&id=5d9805eb"
import script from "./BoCustomerAutorisationsRgbd.vue?vue&type=script&lang=js"
export * from "./BoCustomerAutorisationsRgbd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports